import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { Container } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';

import { formStyles } from 'consts/styles/Form';
import { authGetFileRequestWithParams } from 'helpers/apiRequests';
import { parseDate } from 'utils/main';
import InsideLoader from 'components/common/InsideLoader';
import Icons from 'consts/icons';
import { userStyles } from 'consts/styles/User';
import ButtonsUseStyles from 'consts/styles/Buttons';

const ExportButton = props => {
  const { requestData } = props;
  const timezone = useSelector(state => state.timezone);
  const language = useSelector(state => state.language);
  const [showModal, setShowModal] = React.useState(false);

  const [extension, setExtension] = React.useState('xlsx');

  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  const [
    isRequestFetchingFileData,
    setIsRequestFetchingFileData,
  ] = React.useState(false);

  const handleCreateBlobAndDownload = async () => {
    setShowModal(false);
    setIsRequestFetchingFileData(true);
    const response = await authGetFileRequestWithParams(requestData.url, {
      ...requestData.paramsObj,
      fileType: extension,
    });
    if (response?.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `Report_${parseDate(new Date().getTime(), timezone)}.${extension}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
    setIsRequestFetchingFileData(false);
  };

  const handleChange = e => {
    setExtension(e.target.value);
  };

  return (
    <div
      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--flex-end`}
    >
      {isRequestFetchingFileData && (
        <div
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center`}
        >
          <InsideLoader />
          <span>{language.exportButton.fetchingDataInfo_}</span>
        </div>
      )}
      <Button
        disabled={isRequestFetchingFileData}
        onClick={() => setShowModal(true)}
        className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--small ${classesButtons.ButtonsCircle} `}
      >
        <Icons.Filters.Export />
      </Button>
      <Modal
        open={showModal}
        onClose={setShowModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={classesUser.User}>
          <div className={`${classesUser.User}__settings`}>
            <div className={`${classesUser.User}__settings__content`}>
              <div
                className={`${classesUser.User}__settings__content__spacer`}
              />
              <Container>
                <FormControl
                  fullWidth
                  className={`${formClasses.Form}--flex `}
                  component="fieldset"
                >
                  <Grid
                    item
                    xs
                    className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center`}
                  >
                    <div
                      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}`}
                    >
                      <Icons.Filters.Export />
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="h4"
                      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}__text-field`}
                    >
                      {language.exportButton.fileTypeInfo_}
                    </Typography>
                  </Grid>
                  <RadioGroup
                    aria-label="visibility"
                    name="visibility"
                    value={extension}
                    className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--width`}
                    onChange={handleChange}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={6}
                        className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
                      >
                        <FormControlLabel
                          value="xlsx"
                          control={
                            <Radio className={`${formClasses.Form}__switch`} />
                          }
                          label="Arkusz kalkulacyjny (*.xlsx)"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
                      >
                        <FormControlLabel
                          value="pdf"
                          control={
                            <Radio className={`${formClasses.Form}__switch`} />
                          }
                          label="Plik PDF"
                        />
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
                <div
                  className={`${classesUser.User}__settings__content__spacer`}
                />
                <Container>
                  <Grid spacing={2} container>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        onClick={() => setShowModal(false)}
                        className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} ${classesButtons.Buttons}--reject`}
                      >
                        {language.exportButton.cancel_}
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        onClick={() => handleCreateBlobAndDownload()}
                        className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
                      >
                        {language.exportButton.export_}
                      </Button>
                    </Grid>
                  </Grid>
                </Container>
              </Container>
              <div
                className={`${classesUser.User}__settings__content__spacer`}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

ExportButton.propTypes = {
  requestData: PropTypes.object.isRequired,
};

export default ExportButton;
